var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rounded-corners position-relative border",class:{ 'border-secondary': _vm.disabled,
        'border-info': !_vm.disabled,
        'text-secondary': _vm.disabled,
        'text-info': !_vm.disabled,
        'gallery-add-thumbnail': !_vm.disabled
    },style:({
        width: _vm.getWidth + 'px',
        height: _vm.getHeight + 'px',
        cursor: _vm.disabled ? 'default' : 'pointer',
     }),on:{"click":_vm.onClick}},[_vm._t("icon",[_c('div',{staticClass:"d-flex w-100 h-100 align-items-center justify-content-center"},[_c('span',{staticClass:"h1"},[_c('b-icon',{attrs:{"icon":"plus"}})],1)])]),_c('div',[_c('form',{ref:_vm.formReference},[_c('input',{ref:_vm.inputReference,staticClass:"form-control d-none",attrs:{"multiple":"","type":"file","accept":_vm.inputAccept},on:{"change":_vm.onChange}})])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }